const PAUSED_TASK_REASON = {
	PAUSED_BY_AGENT: 0,
	PAUSED_BY_FINAL_CLIENT: 1,
};

export default PAUSED_TASK_REASON;
